import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";
import { Link } from "react-router-dom";

export default class Deploymentrequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.deploymentrequests_Id,
          sortable: true,
          cell: (row) => <span>{row.deploymentrequests_Id}</span>,
        },
        {
          name: "Request Code",
          selector: (row, i) => row.requestCode,
          sortable: true,
          cell: (row) => <span>{row.requestCode}</span>,
        },
        {
          name: "Project Name",
          selector: (row, i) => row.projectName,
          sortable: true,
          cell: (row) => <span>{row.projectName}</span>,
        },
        {
          name: "Source Project",
          selector: (row, i) => row.sourceProject,
          sortable: true,
          cell: (row) => <span>{row.sourceProject}</span>,
        },
        {
          name: "Target Environment",
          selector: (row, i) => row.targetEnvironment,
          sortable: true,
          cell: (row) => <span>{row.targetEnvironment}</span>,
        },
        {
          name: "Action Type",
          selector: (row, i) => row.actionType,
          sortable: true,
          cell: (row) => <span>{row.actionType}</span>,
        },
        {
          name: "Priority",
          selector: (row, i) => row.priority,
          sortable: true,
          cell: (row) => <span>{row.priority}</span>,
        },
        {
          name: "Target Environment",
          selector: (row, i) => row.targetEnvironment,
          sortable: true,
          cell: (row) => <span>{row.targetEnvironment}</span>,
        },
        {
          name: "Action Type",
          selector: (row, i) => row.actionType,
          sortable: true,
          cell: (row) => <span>{row.actionType}</span>,
        },
        {
          name: "Priority",
          selector: (row, i) => row.priority,
          sortable: true,
          cell: (row) => <span>{row.priority}</span>,
        },
        {
          name: "Reason For Deployment",
          selector: (row, i) => row.reasonForDeployment,
          sortable: true,
          cell: (row) => <span>{row.reasonForDeployment}</span>,
        },
        {
          name: "Requested By",
          selector: (row, i) => row.requestedBy,
          sortable: true,
          cell: (row) => <span>{row.requestedBy}</span>,
        },
        {
          name: "Assigned To",
          selector: (row, i) => row.assignedTo,
          sortable: true,
          cell: (row) => <span>{row.assignedTo}</span>,
        },
        {
          name: "Request Date",
          selector: (row, i) => row.requestDate,
          sortable: true,
          cell: (row) => <span>{row.requestDate}</span>,
        },
        {
          name: "Deployment Date",
          selector: (row, i) => row.deploymentDate,
          sortable: true,
          cell: (row) => <span>{row.deploymentDate}</span>,
        },
        {
          name: "Deployment Status",
          selector: (row, i) => row.deploymentStatus,
          sortable: true,
          cell: (row) => <span>{row.deploymentStatus}</span>,
        },
        {
          name: "Remarks",
          selector: (row, i) => row.remarks,
          sortable: true,
          cell: (row) => <span>{row.remarks}</span>,
        },
        {
          name: "Status",
          selector: (row, i) => row.status,
          sortable: true,
          cell: (row) => <span>{row.status}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.DeploymentrequestseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      deploymentrequests_Id: "",
      requestCode: "",
      projectName: "",
      sourceProject: "",
      targetEnvironment: "",
      actionType: "",
      priority: "",
      reasonForDeployment: "",
      requestedBy: "",
      assignedTo: "",
      requestDate: "",
      deploymentDate: "",
      deploymentStatus: "",
      remarks: "",
      status: "",
      Environmentmaster: [],
      Deploymentactiontypemaster: [],
      Testcaseprioritymaster: [],
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "requestCode",
        inputType: "Text",
        displayName: "Request Code",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "projectName",
        inputType: "Text",
        displayName: "Project Name",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "sourceProject",
        inputType: "Text",
        displayName: "Source Project",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "targetEnvironment",
        inputType: "Text",
        displayName: "Target Environment",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "actionType",
        inputType: "Text",
        displayName: "Action Type",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "priority",
        inputType: "Text",
        displayName: "Priority",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "reasonForDeployment",
        inputType: "Text",
        displayName: "Reason For Deployment",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "requestedBy",
        inputType: "Number",
        displayName: "Requested By",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "assignedTo",
        inputType: "Number",
        displayName: "Assigned To",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "requestDate",
        inputType: "Date",
        displayName: "Request Date",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "deploymentDate",
        inputType: "Date",
        displayName: "Deployment Date",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "deploymentStatus",
        inputType: "Text",
        displayName: "Deployment Status",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "remarks",
        inputType: "Text",
        displayName: "Remarks",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "status",
        inputType: "Number",
        displayName: "Status",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      requestCode: "",
      projectName: "",
      sourceProject: "",
      targetEnvironment: "",
      actionType: "",
      priority: "",
      reasonForDeployment: "",
      requestedBy: "",
      assignedTo: "",
      requestDate: "",
      deploymentDate: "",
      deploymentStatus: "",
      remarks: "",
      status: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      requestCode: "",
      projectName: "",
      sourceProject: "",
      targetEnvironment: "",
      actionType: "",
      priority: "",
      reasonForDeployment: "",
      requestedBy: "",
      assignedTo: "",
      requestDate: "",
      deploymentDate: "",
      deploymentStatus: "",
      remarks: "",
      status: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  DeploymentrequestseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      deploymentrequests_Id: row.deploymentrequests_Id,
      requestCode: row.requestCode,
      projectName: row.projectName,
      sourceProject: row.sourceProject,
      targetEnvironment: row.targetEnvironment,
      actionType: row.actionType,
      priority: row.priority,
      reasonForDeployment: row.reasonForDeployment,
      requestedBy: row.requestedBy,
      assignedTo: row.assignedTo,
      requestDate: row.requestDate,
      deploymentDate: row.deploymentDate,
      deploymentStatus: row.deploymentStatus,
      remarks: row.remarks,
      status: row.status,
      //***editstate
      errors: {},
      touched: {},
    });
  };

  DeploymentrequestsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentrequests/listByTeam", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  EnvironmentmasterfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Environmentmaster/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ Environmentmaster: data.list });
        }
      })

      .catch((error) => {
        console.error("Fetch error:", error);

        this.showToast("Failed to load data", "error");
      });
  };
  DeploymentactiontypemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentactiontypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Deploymentactiontypemaster: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  TestcaseprioritymasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Testcaseprioritymaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Testcaseprioritymaster: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  DeploymentrequestssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("requestCode", this.state.requestCode);
    formData.append("projectName", this.state.projectName);
    formData.append("sourceProject", this.state.sourceProject);
    formData.append("targetEnvironment", this.state.targetEnvironment);
    formData.append("actionType", this.state.actionType);
    formData.append("priority", this.state.priority);
    formData.append("reasonForDeployment", this.state.reasonForDeployment);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("assignedTo", this.state.assignedTo);
    formData.append("requestDate", this.state.requestDate);
    formData.append("deploymentDate", this.state.deploymentDate);
    formData.append("deploymentStatus", this.state.deploymentStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("status", this.state.status);

    //***tableData*

    fetch(configData.api_url + "C_Deploymentrequests/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentrequestsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            requestCode: "",
            projectName: "",
            sourceProject: "",
            targetEnvironment: "",
            actionType: "",
            priority: "",
            reasonForDeployment: "",
            requestedBy: "",
            assignedTo: "",
            requestDate: "",
            deploymentDate: "",
            deploymentStatus: "",
            remarks: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };

  DeploymentrequestsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentrequests_Id", this.state.deploymentrequests_Id);
    formData.append("requestCode", this.state.requestCode);
    formData.append("projectName", this.state.projectName);
    formData.append("sourceProject", this.state.sourceProject);
    formData.append("targetEnvironment", this.state.targetEnvironment);
    formData.append("actionType", this.state.actionType);
    formData.append("priority", this.state.priority);
    formData.append("reasonForDeployment", this.state.reasonForDeployment);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("assignedTo", this.state.assignedTo);
    formData.append("requestDate", this.state.requestDate);
    formData.append("deploymentDate", this.state.deploymentDate);
    formData.append("deploymentStatus", this.state.deploymentStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("status", this.state.status);

    //***tableData1

    fetch(configData.api_url + "C_Deploymentrequests/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentrequestsfetchHandler();
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      });
  };

  componentDidMount() {
    this.DeploymentrequestsfetchHandler();
    this.EnvironmentmasterfetchHandler();
    this.DeploymentactiontypemasterfetchHandler();
    this.TestcaseprioritymasterfetchHandler();
    //***componentDidMount
  }

  handlerequestCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestCode: fieldValue });
  };
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ projectName: fieldValue });
  };
  handlesourceProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sourceProject: fieldValue });
  };
  handletargetEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ targetEnvironment: fieldValue });
  };
  handleactionTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actionType: fieldValue });
  };
  handlepriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  };
  handlereasonForDeploymentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ reasonForDeployment: fieldValue });
  };
  handlerequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestedBy: fieldValue });
  };
  handleassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assignedTo: fieldValue });
  };
  handlerequestDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ requestDate: fieldValue });
  };
  handledeploymentDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ deploymentDate: fieldValue });
  };
  handledeploymentStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentStatus: fieldValue });
  };
  handleremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handlestatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this deploymentrequests?`,
      )
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("deploymentrequests_Id", row.deploymentrequests_Id);

    fetch(configData.api_url + "C_Deploymentrequests/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentrequestsfetchHandler();
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Deployment Requests
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Link to="/deploymentrequestpage">
                        <Button
                          variant="primary"
                          style={{ float: "right", marginBottom: "10px" }}
                          className="bi bi-plus "
                        >
                          New Request
                        </Button>
                      </Link>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Deploymentrequests
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Request Code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlerequestCodeChange}
                                        className="form-control"
                                        name="requestCode"
                                        value={this.state.requestCode}
                                        required="required"
                                        placeholder="Enter Request Code"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.requestCode}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleprojectNameChange}
                                        className="form-control"
                                        name="projectName"
                                        value={this.state.projectName}
                                        required="required"
                                        placeholder="Enter Project Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.projectName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Source Project
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesourceProjectChange
                                        }
                                        className="form-control"
                                        name="sourceProject"
                                        value={this.state.sourceProject}
                                        required="required"
                                        placeholder="Enter Source Project"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.sourceProject}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Target Environment
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={
                                          this.handletargetEnvironmentChange
                                        }
                                        className="form-control"
                                        name="targetEnvironment"
                                        value={this.state.targetEnvironment}
                                        required="required"
                                        placeholder="Enter Target Environment"
                                      >
                                        <option defaultValue>
                                          Select Target Environment
                                        </option>
                                        {this.state.Environmentmaster.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.development}
                                            >
                                              {api.development}
                                              {/* {api.fName}&nbsp;{api.lName} */}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.targetEnvironment}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Action Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={this.handleactionTypeChange}
                                        className="form-control"
                                        name="actionType"
                                        value={this.state.actionType}
                                        required="required"
                                        placeholder="Enter Action Type"
                                      >
                                        <option defaultValue>
                                          Select Action Type
                                        </option>
                                        {this.state.Deploymentactiontypemaster.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.actionType}
                                            >
                                              {api.actionType}
                                              {/* {api.fName}&nbsp;{api.lName} */}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Priority
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        type="text"
                                        onChange={this.handlepriorityChange}
                                        className="form-control"
                                        name="priority"
                                        value={this.state.priority}
                                        required="required"
                                        placeholder="Enter Priority"
                                      >
                                        <option defaultValue>Select</option>
                                        {this.state.Testcaseprioritymaster.map(
                                          (api, index, idx) => (
                                            <option key={index} value={api.low}>
                                              {api.low}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.priority}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Reason For Deployment
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlereasonForDeploymentChange
                                        }
                                        className="form-control"
                                        name="reasonForDeployment"
                                        value={this.state.reasonForDeployment}
                                        required="required"
                                        placeholder="Enter Reason For Deployment"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.reasonForDeployment
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Requested By
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlerequestedByChange}
                                        className="form-control"
                                        name="requestedBy"
                                        value={this.state.requestedBy}
                                        required="required"
                                        placeholder="Enter Requested By"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.requestedBy}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Assigned To
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleassignedToChange}
                                        className="form-control"
                                        name="assignedTo"
                                        value={this.state.assignedTo}
                                        required="required"
                                        placeholder="Enter Assigned To"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.assignedTo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Request Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handlerequestDateChange}
                                        className="form-control"
                                        name="requestDate"
                                        value={this.state.requestDate}
                                        required="required"
                                        placeholder="Enter Request Date"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.requestDate}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handledeploymentDateChange
                                        }
                                        className="form-control"
                                        name="deploymentDate"
                                        value={this.state.deploymentDate}
                                        required="required"
                                        placeholder="Enter Deployment Date"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.deploymentDate}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledeploymentStatusChange
                                        }
                                        className="form-control"
                                        name="deploymentStatus"
                                        value={this.state.deploymentStatus}
                                        required="required"
                                        placeholder="Enter Deployment Status"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.deploymentStatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Remarks
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleremarksChange}
                                        className="form-control"
                                        name="remarks"
                                        value={this.state.remarks}
                                        required="required"
                                        placeholder="Enter Remarks"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.remarks}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlestatusChange}
                                        className="form-control"
                                        name="status"
                                        value={this.state.status}
                                        required="required"
                                        placeholder="Enter Status"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.status}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.DeploymentrequestssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Deploymentrequests
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Request Code
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlerequestCodeChange
                                          }
                                          className="form-control"
                                          name="requestCode"
                                          value={this.state.requestCode}
                                          required="required"
                                          placeholder="Enter Request Code"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.requestCode}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleprojectNameChange
                                          }
                                          className="form-control"
                                          name="projectName"
                                          value={this.state.projectName}
                                          required="required"
                                          placeholder="Enter Project Name"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.projectName}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Source Project
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlesourceProjectChange
                                          }
                                          className="form-control"
                                          name="sourceProject"
                                          value={this.state.sourceProject}
                                          required="required"
                                          placeholder="Enter Source Project"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.sourceProject}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Target Environment
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={
                                            this.handletargetEnvironmentChange
                                          }
                                          className="form-control"
                                          name="targetEnvironment"
                                          value={this.state.targetEnvironment}
                                          required="required"
                                          placeholder="Enter Target Environment"
                                        >
                                          <option defaultValue>
                                            Select Target Environment
                                          </option>
                                          {this.state.Environmentmaster.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.development}
                                              >
                                                {api.development}
                                                {/* {api.fName}&nbsp;{api.lName} */}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.targetEnvironment
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Action Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={this.handleactionTypeChange}
                                          className="form-control"
                                          name="actionType"
                                          value={this.state.actionType}
                                          required="required"
                                          placeholder="Enter Action Type"
                                        >
                                          <option defaultValue>
                                            Select Action Type
                                          </option>
                                          {this.state.Deploymentactiontypemaster.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.actionType}
                                              >
                                                {api.actionType}
                                                {/* {api.fName}&nbsp;{api.lName} */}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Priority
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          type="text"
                                          onChange={this.handlepriorityChange}
                                          className="form-control"
                                          name="priority"
                                          value={this.state.priority}
                                          required="required"
                                          placeholder="Enter Priority"
                                        >
                                          <option defaultValue>Select</option>
                                          {this.state.Testcaseprioritymaster.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.low}
                                              >
                                                {api.low}
                                              </option>
                                            ),
                                          )}
                                        </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.priority}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Reason For Deployment
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlereasonForDeploymentChange
                                          }
                                          className="form-control"
                                          name="reasonForDeployment"
                                          value={this.state.reasonForDeployment}
                                          required="required"
                                          placeholder="Enter Reason For Deployment"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.reasonForDeployment
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Requested By
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handlerequestedByChange
                                          }
                                          className="form-control"
                                          name="requestedBy"
                                          value={this.state.requestedBy}
                                          required="required"
                                          placeholder="Enter Requested By"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.requestedBy}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Assigned To
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleassignedToChange}
                                          className="form-control"
                                          name="assignedTo"
                                          value={this.state.assignedTo}
                                          required="required"
                                          placeholder="Enter Assigned To"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.assignedTo}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Request Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handlerequestDateChange
                                          }
                                          className="form-control"
                                          name="requestDate"
                                          value={this.state.requestDate}
                                          required="required"
                                          placeholder="Enter Request Date"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.requestDate}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handledeploymentDateChange
                                          }
                                          className="form-control"
                                          name="deploymentDate"
                                          value={this.state.deploymentDate}
                                          required="required"
                                          placeholder="Enter Deployment Date"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.deploymentDate}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledeploymentStatusChange
                                          }
                                          className="form-control"
                                          name="deploymentStatus"
                                          value={this.state.deploymentStatus}
                                          required="required"
                                          placeholder="Enter Deployment Status"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.deploymentStatus
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleremarksChange}
                                          className="form-control"
                                          name="remarks"
                                          value={this.state.remarks}
                                          required="required"
                                          placeholder="Enter Remarks"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.remarks}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlestatusChange}
                                          className="form-control"
                                          name="status"
                                          value={this.state.status}
                                          required="required"
                                          placeholder="Enter Status"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.status}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.DeploymentrequestsupdateHandler
                                    }
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
